import camilaPhoto from "@/assets/team-camila.jpg";
import luisaPhoto from "@/assets/team-luisa.jpg";
import marceloPhoto from "@/assets/team-marcelo.jpg";
import isabelaPhoto from "@/assets/team-isabela.jpg";

export type TeamMember = {
  name: string;
  role: string;
  bio: string;
  photo: string;
  initials: string;
  accent: string;
};

export const TEAM: TeamMember[] = [
  {
    name: "Rafael Monteiro",
    role: "Editor-chefe",
    bio: "Coordena a linha editorial do Concurso Astor. Escreve sobre gestão, produtividade e cultura empresarial para PMEs e empreendedores.",
    initials: "RM",
    accent: "#111111",
    photo: camilaPhoto,
  },
  {
    name: "Beatriz Lacerda",
    role: "Editora — Gestão e Operações",
    bio: "Cobre pautas de gestão, processos, tomada de decisão e boas práticas operacionais em empresas de todos os portes.",
    initials: "BL",
    accent: "#3F3F46",
    photo: luisaPhoto,
  },
  {
    name: "Thiago Bastos",
    role: "Editor — Estratégia e Negócios",
    bio: "Analisa modelos de negócio, estratégia competitiva, finanças e crescimento sustentável para empreendedores e donos de empresa.",
    initials: "TB",
    accent: "#52525B",
    photo: marceloPhoto,
  },
  {
    name: "Helena Vasconcelos",
    role: "Editora — Vendas e Marketing",
    bio: "Escreve sobre vendas, marketing digital, aquisição de clientes e posicionamento para empresas em crescimento.",
    initials: "HV",
    accent: "#18181B",
    photo: isabelaPhoto,
  },
];
